import { defineComponent as b, computed as n, openBlock as o, createElementBlock as g, mergeProps as f, createBlock as d, unref as v, normalizeClass as i, resolveDynamicComponent as p, renderSlot as y } from "vue";
import { I as x } from "./IconLoader2-tUjfbfXu.js";
const w = ["disabled"], z = /* @__PURE__ */ b({
  inheritAttrs: !1,
  __name: "IconButton",
  props: {
    variant: { default: "ghost" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: { default: void 0 }
  },
  emits: ["click"],
  setup(s, { emit: l }) {
    const t = s, c = l, m = (e) => {
      !t.disabled && !t.loading && c("click", e);
    }, a = n(() => {
      switch (t.size) {
        case "sm":
          return "w-4 h-4";
        case "lg":
          return "w-6 h-6";
        case "xl":
          return "w-7 h-7";
        default:
          return "w-5 h-5";
      }
    }), u = n(() => {
      const e = [], r = {
        primary: [
          "bg-primary",
          "text-primary-content",
          "shadow-sm",
          "hover:bg-primary/90",
          "hover:shadow-md"
        ],
        secondary: [
          "bg-secondary",
          "text-secondary-content",
          "shadow-sm",
          "hover:bg-secondary/90",
          "hover:shadow-md"
        ],
        neutral: [
          "bg-bg-card",
          "text-text-main",
          "shadow-sm",
          "border",
          "border-stone-200",
          "hover:border-secondary",
          "hover:text-secondary",
          "hover:shadow-md"
        ],
        outline: [
          "bg-transparent",
          "border-2",
          "border-text-main",
          "text-text-main",
          "hover:bg-stone-50"
        ],
        soft: ["bg-secondary", "text-secondary", "hover:shadow-sm"],
        ghost: [
          "bg-transparent",
          "text-text-muted",
          "hover:bg-bg-surface-hover",
          "hover:text-text-main"
        ],
        danger: [
          "bg-error",
          "text-white",
          "shadow-sm",
          "hover:bg-red-600",
          "hover:shadow-md"
        ]
      }, h = {
        sm: ["p-1.5"],
        md: ["p-2"],
        lg: ["p-3"],
        xl: ["p-3.5"]
      };
      return t.variant && e.push(...r[t.variant]), t.size && e.push(...h[t.size]), e;
    });
    return (e, r) => (o(), g("button", f({
      class: ["inline-flex items-center justify-center font-medium transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed relative focus-ring rounded-button", u.value],
      disabled: s.disabled || s.loading
    }, e.$attrs, { onClick: m }), [
      s.loading ? (o(), d(v(x), {
        key: 0,
        class: i(["animate-spin", a.value])
      }, null, 8, ["class"])) : s.icon ? (o(), d(p(s.icon), {
        key: 1,
        class: i(a.value)
      }, null, 8, ["class"])) : y(e.$slots, "default", { key: 2 })
    ], 16, w));
  }
});
export {
  z as _
};
